<div *ngIf="!isSdfCardFlow" class="mat-step-finished-confirmation">
  <p class="mg-step-header">{{ labels?.stellar?.confirmation?.header }}</p>
  <ng-container
    *ngIf="flow === 'deposit' && !isformFreeLocation; else referenceNumber"
  >
    <p *ngIf="confirmationCode" class="reference-number">
      {{ getConfirmationCode() }}
    </p>
  </ng-container>
  <ng-template #referenceNumber>
    <p *ngIf="refNumber" class="reference-number">{{ getRefDetails() }}</p>
  </ng-template>

  <app-status-updates
    [flow]="flow"
    [wallet]="walletProvider"
    [labels]="labels"
    [isformFreeLocation]="isformFreeLocation"
  ></app-status-updates>

  <div *ngIf="locationFinderService.selectedBranch">
    <app-location-search-detail
      [flow]="flow"
      [labels]="locationLabels"
      [showChangeLocator]="false"
      [pinSelectedLocation]="
        locationFinderService.selectedBranch ? true : false
      "
    ></app-location-search-detail>
  </div>

  <div class="mg-step-actions-row">
    <app-moneygram-locations-link
      [google]="google"
      [kind]="flow"
      [labels]="labels"
      [displaySuperscript]="true"
    ></app-moneygram-locations-link>

    <p class="helpText" *ngIf="flow === 'withdraw'">
      {{ labels?.stellar?.confirmation?.helpText }}
    </p>

    <app-indicative-rate-note class="full-width"></app-indicative-rate-note>

    <app-walmart-footnote
      *ngIf="flow === 'withdraw'"
      [labels]="labels"
    ></app-walmart-footnote>

    <button color="primary" mat-raised-button (click)="handleDone()">
      {{ labels?.stellar?.ok }}
    </button>
    <a class="mg-action" href="javascript:void(0)" (click)="printPage()">{{
      labels?.stellar?.saveAsImage
    }}</a>
  </div>
</div>

<div class="confirmation-wrapper">
  <div *ngIf="isSdfCardFlow" class="card-confirmation-styles">
    <!-- <img class="status-logo" src="assets/images/trn-status-ellipse.svg" alt="MoneyGram" /> -->

    <!-- <div class="status-styles">{{transactionStatus.status}}</div> -->

    <!-- <div class="ref-num-section"> -->
    <!-- <div class="ref-num">
                {{getRefDetails()}}
            </div> -->
    <!-- <ng-container *ngIf="flow === 'deposit' && !isformFreeLocation else referenceNumber;">
                <p class="ref-num">{{getConfirmationCode()}}</p>
            </ng-container>
            <ng-template #referenceNumber>
                <p *ngIf="refNumber" class="ref-num">{{getRefDetails()}}</p>
            </ng-template>
            <div class="ref-share-icon">
              <img class="status-logo" src="assets/images/icon-close.svg" alt="reference-number-share" />
            </div>
        </div>
    
        <div class="trn-status-help-text">{{transactionStatus.helpText}}</div>
    
        <div class="pay-instructions-section">
            <p>How to pay your cash at location</p> 
        </div> -->

    <div class="title-instructions-container">
      <div class="title-and-icon">
        <img
          src="assets/images/green-confirmation-icon.svg"
          alt="confirmation-icon"
        />
        <div class="header">
          <ng-container *ngIf="flow === 'deposit'">
            <p class="header-text">
              {{ sdfCardLabels.confirmationPage.cashInStatusHeader }}
            </p>
          </ng-container>
          <ng-container *ngIf="flow === 'withdraw'">
            <p class="header-text">
              {{ sdfCardLabels.confirmationPage.cashOutStatusHeader }}
            </p>
          </ng-container>
        </div>
      </div>

      <ng-container
        *ngIf="
          (flow === 'deposit' && !isformFreeLocation) || flow === 'withdraw'
        "
      >
        <div class="button-filled-trans">
          <div class="confirmation">
            {{ getConfirmationCode() }}
          </div>
          <img
            src="assets/images/share-icon.svg"
            alt="share-icon"
            (click)="copyCode()"
          />
        </div>
      </ng-container>
      <div class="amount-and-reciever">
        <div class="pay-at-store">
          <ng-container *ngIf="flow === 'deposit'">
            <p class="pay-at-store-text">
              {{ sdfCardLabels.confirmationPage.payAtStore }}
            </p>
          </ng-container>
          <ng-container *ngIf="flow === 'withdraw'">
            <p class="pay-at-store-text">
              {{ sdfCardLabels.confirmationPage.pickAmount }}
            </p>
          </ng-container>
        </div>
        <div class="amount-currency">
          <p class="amount-text">
            {{ getTotalAmount() }}
          </p>
          <p class="currency">
            {{ getTotalExchangeAmountCurrency() }}
          </p>
        </div>
        <div class="adding-funds-to-wallat">
          <ng-container *ngIf="flow === 'deposit'">
            <p class="adding-funds-to-wallet-text">
              {{ getDepositAmountString() }}
            </p>
          </ng-container>
          <ng-container *ngIf="flow === 'withdraw'">
            <p class="adding-funds-to-wallet-text">
              {{ getWithdrawAmountString() }}
            </p>
          </ng-container>
        </div>
        <div class="receiver-details">
          <p class="receiver-text-label">
            {{ sdfCardLabels.confirmationPage.receiver }}:
          </p>

          <p class="amount-label">
            {{ getReceiverFullName() }}
          </p>
        </div>
      </div>
      <div class="next-steps-wrapper">
        <div class="next-steps">
          <div class="header">
            <p class="header-text">
              {{ sdfCardLabels.confirmationPage.nextStepsHeading }}
            </p>
          </div>
          <!-- Implicit US Canada and deposit flow  -->
          <ng-container
            *ngIf="
              !isformFreeLocation &&
              flow === 'deposit' &&
              isImplicitUSCanLocation
            "
          >
            <div class="next-steps-items">
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 1 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishWithIn"
                  class="item-details"
                >
                  Within <span class="hours-bold">24 hours</span>, head to
                  <span class="paymentLocation-bold-underline"
                    >your payment location</span
                  >
                </div>
                <ng-template #nonEnglishWithIn>
                  <div class="item-details">
                    {{ sdfCardLabels.confirmationPage.nextSteps.paraOne }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 2 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishIdOne"
                  class="item-details"
                >
                  Have your
                  <span class="photo-id">{{
                    getSelectedIdInfo(primaryIdDetails)
                  }}</span>
                  selected and
                  <span class="accouunt-bold">Account #</span> above ready
                </div>
                <ng-template #nonEnglishIdOne>
                  <div class="item-details">
                    {{ getPrimaryIdString() }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 3 </span>
                </div>
                <div class="item-details-wrapper">
                  <div class="item-details">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps
                        .tellTheStoreEmployee
                    }}
                  </div>
                  <div
                    *ngIf="isEnglishFlow; else nonEnglishSendMoney"
                    class="item-details bold"
                  >
                    I am here to send money to <span class="state">Texas</span>,
                    <span class="country">United States.</span>
                  </div>
                  <ng-template #nonEnglishSendMoney>
                    <div class="item-details bold">
                      {{
                        sdfCardLabels.confirmationPage.nextSteps.fundsIn
                          .paraThree.implicitTransUSCAN.purpose
                      }}.
                    </div>
                  </ng-template>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .serviceOption
                    }}
                  </div>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .yourNameAsReceiver
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- formFreeLocation none US and Canada countries and deposit flow -->
          <ng-container
            *ngIf="
              !isformFreeLocation &&
              flow === 'deposit' &&
              !isImplicitUSCanLocation
            "
          >
            <div class="next-steps-items">
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 1 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishWithIn"
                  class="item-details"
                >
                  Within <span class="hours-bold">24 hours</span>, head to
                  <span class="paymentLocation-bold-underline"
                    >your payment location</span
                  >
                </div>
                <ng-template #nonEnglishWithIn>
                  <div class="item-details">
                    {{ sdfCardLabels.confirmationPage.nextSteps.paraOne }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 2 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishIdOne"
                  class="item-details"
                >
                  Have your
                  <span class="photo-id">{{
                    getSelectedIdInfo(primaryIdDetails)
                  }}</span>
                  selected and
                  <span class="accouunt-bold">Account #</span> above ready
                </div>
                <ng-template #nonEnglishIdOne>
                  <div class="item-details">
                    {{ getPrimaryIdString() }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 3 </span>
                </div>
                <div class="item-details-wrapper">
                  <div class="item-details">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps
                        .tellTheStoreEmployee
                    }}
                  </div>
                  <div
                    *ngIf="isEnglishFlow; else nonEnglishSendMoney"
                    class="item-details bold"
                  >
                    I am here to send money to
                    <span class="country">the United States.</span>
                  </div>
                  <ng-template #nonEnglishSendMoney>
                    <div class="item-details bold">
                      {{
                        sdfCardLabels.confirmationPage.nextSteps.fundsIn
                          .paraThree.implicitNoneUSCAN.purpose
                      }}.
                    </div>
                  </ng-template>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .serviceOption
                    }}
                  </div>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .yourNameAsReceiver
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Explicit cashin and deposit flow next steps -->
          <div
            class="next-steps-items"
            *ngIf="isformFreeLocation && flow === 'deposit'"
          >
            <div class="item-group">
              <div class="item-number">
                <span class="number"> 1 </span>
              </div>
              <div
                *ngIf="isEnglishFlow; else nonEnglishWithIn"
                class="item-details"
              >
                Within <span class="hours-bold">24 hours</span>, head to
                <span class="paymentLocation-bold-underline"
                  >your payment location</span
                >
              </div>
              <ng-template #nonEnglishWithIn>
                <div class="item-details">
                  {{ sdfCardLabels.confirmationPage.nextSteps.paraOne }}
                </div>
              </ng-template>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number"> 2 </span>
              </div>
              <div
                *ngIf="isEnglishFlow; else nonEnglishIdOne"
                class="item-details"
              >
                Have your
                <span class="photo-id">{{
                  getSelectedIdInfo(primaryIdDetails)
                }}</span>
                selected
              </div>
              <ng-template #nonEnglishIdOne>
                <div class="item-details">
                  {{ getPrimaryIdString() }}
                </div>
              </ng-template>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number"> 3 </span>
              </div>
              <div class="item-details-wrapper">
                <div
                  class="item-details"
                  *ngIf="isEnglishFlow; else noneEnglishpurpose"
                >
                  {{
                    splitExplicitPurpose(
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.paraThree
                        .explicit.purpose
                    )[0]
                  }},
                  <span class="bold">{{
                    splitExplicitPurpose(
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.paraThree
                        .explicit.purpose
                    )[1]
                  }}</span>
                </div>
                <ng-template #noneEnglishpurpose>
                  <div class="item-details">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.paraThree
                        .explicit.purpose
                    }}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <!-- Withdraw flow next steps -->
          <div class="next-steps-items" *ngIf="flow === 'withdraw'">
            <div
              *ngIf="
                bulletStepsWithdraw.option === 'return2WalletWithdrawFunds'
              "
            >
              <div class="item-group">
                <!-- <div class="item-group-wrapper"> -->
                <div class="item-number">
                  <span class="number">{{
                    bulletStepsWithdraw[bulletStepsWithdraw.option].step1
                  }}</span>
                </div>
                <div
                  class="item-details"
                  [innerHTML]="
                    labels?.stellar?.statusUpdates?.withdraw?.firstBulletLobstr
                  "
                ></div>
              </div>
            </div>
            <div class="item-group">
              <!-- <div class="item-group-wrapper"> -->
              <div class="item-number">
                <span class="number">
                  {{ bulletStepsWithdraw[bulletStepsWithdraw.option].step2 }}
                </span>
              </div>
              <div class="item-details location">
                <div
                  *ngIf="isEnglishFlow; else nonEnglishWithin"
                  class="first-content"
                >
                  Within <span class="days-bold">60 days</span>, head to
                  <span class="pickup-Location-bold"
                    >any store from your search result</span
                  >
                </div>
                <ng-template #nonEnglishWithin class="first-content">
                  <div class="item-details">
                    {{ sdfCardLabels.confirmationPage.nextSteps.fundsOut.paraOne }}
                  </div>
                </ng-template>
                <div class="lookup-location">
                  <app-moneygram-locations-link
                    [google]="google"
                    [kind]="flow"
                    [isSdfCardFlow]="true"
                    [labels]="labels"
                    [flow]="flow"
                  ></app-moneygram-locations-link>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <div class="item-group">
              <div class="item-number">
                <span class="number">
                  {{ bulletStepsWithdraw[bulletStepsWithdraw.option].step3 }}
                </span>
              </div>
              <div
                *ngIf="isEnglishFlow; else nonEnglishId"
                class="item-details"
              >
                Have your
                <span class="photo-id">{{
                  getSelectedIdInfo(primaryIdDetails)
                }}</span>
                selected and
                <span class="accouunt-bold">Reference #</span> above ready
              </div>
              <ng-template #nonEnglishId class="item-details">
                <div class="item-details">
                  {{ getPrimaryIdString() }}
                </div>
              </ng-template>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number">
                  {{ bulletStepsWithdraw[bulletStepsWithdraw.option].step4 }}
                </span>
              </div>
              <div class="item-details-wrapper">
                <div class="item-details">
                  {{
                    sdfCardLabels.confirmationPage.nextSteps
                      .tellTheStoreEmployee
                  }}
                </div>
                <div class="item-details bold">
                  {{
                    sdfCardLabels.confirmationPage.nextSteps.fundsOut
                      .receiveCash
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="divider"></div>
          <div class="help-text">
            <p class="help-text-label">
              {{ sdfCardLabels.confirmationPage.walletBalance }}.
            </p>
          </div>
        </div>
      </div>
    </div>

    <app-card-summary-section
      *ngFor="let section of sections"
      [items]="section.items"
      [title]="section.title"
      [footer]="section.footer"
    >
    </app-card-summary-section>

    <!-- <div class="mg-step-actions-row">
          <button color="primary" mat-raised-button>Done</button>
        </div> -->
    <section class="form-button-container">
      <div class="button-container">
        <button class="formBtn" (click)="handleDone()">
          <span class="label">{{ sdfCardLabels.common.done }}</span>
        </button>
      </div>
    </section>
  </div>
  <app-powered-by-stellar
    class="powered-by-stellar-contiainer"
  ></app-powered-by-stellar>
</div>
